export const bikeBrands = [
	// Last value added 616 : RADIOR
	// 312 (doublon Merida)
	{
		value: 999,
		label: "bike:bike_types.other_brand",
	},
	{
		label: "1886",
		value: 380,
	},
	{
		label: "3T",
		value: 251,
	},
	{
		label: "6Ku",
		value: 381,
	},
	{
		label: "Abrar",
		value: 382,
	},
	{
		label: "Achielle",
		value: 383,
	},
	{
		label: "Actimover",
		value: 384,
	},
	{
		label: "Addbike",
		value: 1,
	},
	{
		label: "Adore",
		value: 385,
	},
	{
		label: "Adriatica",
		value: 354,
	},
	{
		label: "Adris",
		value: 386,
	},
	{
		label: "Aevon Bikes",
		value: 315,
	},
	{
		label: "Agora",
		value: 387,
	},
	{
		label: "Ahooga",
		value: 350,
	},
	{
		label: "Alérion Cycles",
		value: 388,
	},
	{
		label: "Alex Hinault",
		value: 389,
	},
	{
		label: "Alex Singer",
		value: 2,
	},
	{
		label: "Allos bikes",
		value: 307,
	},
	{
		label: "Alpina",
		value: 390,
	},
	{
		label: "Amsterdamair",
		value: 3,
	},
	{
		label: "Analog Motion",
		value: 391,
	},
	{
		label: "Ancheer",
		value: 392,
	},
	{
		label: "Angell",
		value: 4,
	},
	{
		label: "Apache",
		value: 393,
	},
	{
		label: "Arcade",
		value: 5,
	},
	{
		label: "Argon 18",
		value: 6,
	},
	{
		label: "Armony",
		value: 394,
	},
	{
		label: "Arrow",
		value: 7,
	},
	{
		label: "Atala",
		value: 395,
	},
	{
		label: "Ateliers Heritagebike",
		value: 396,
	},
	{
		label: "Atlas Bike",
		value: 8,
	},
	{
		label: "Attala",
		value: 9,
	},
	{
		label: "Aurelia",
		value: 397,
	},
	{
		label: "Aventon",
		value: 10,
	},
	{
		label: "Avenue",
		value: 398,
	},
	{
		label: "Avigo",
		value: 11,
	},
	{
		label: "Azor",
		value: 399,
	},
	{
		label: "Azub",
		value: 400,
	},
	{
		label: "B2Ebike",
		value: 401,
	},
	{
		label: "Babboe",
		value: 12,
	},
	{
		label: "Bakfiets",
		value: 13,
	},
	{
		label: "Balmoral",
		value: 402,
	},
	{
		label: "Banshee",
		value: 14,
	},
	{
		label: "Barracuda",
		value: 403,
	},
	{
		label: "Basic Sport",
		value: 404,
	},
	{
		label: "Basso",
		value: 15,
	},
	{
		label: "Batavus",
		value: 16,
	},
	{
		label: "Bayck",
		value: 405,
	},
	{
		label: "Beaufort",
		value: 17,
	},
	{
		label: "B'ebike",
		value: 355,
	},
	{
		label: "Beixo",
		value: 406,
	},
	{
		label: "Bemoov",
		value: 407,
	},
	{
		label: "Benno",
		value: 292,
	},
	{
		label: "Bergamont",
		value: 287,
	},
	{
		label: "Bernard Hinault",
		value: 18,
	},
	{
		label: "Bernard Thevenet",
		value: 19,
	},
	{
		label: "Berria",
		value: 323,
	},
	{
		label: "Bertaud",
		value: 20,
	},
	{
		label: "Bertin",
		value: 21,
	},
	{
		label: "BH",
		value: 24,
	},
	{
		label: "Bianchi",
		value: 22,
	},
	{
		label: "Bicicapcae",
		value: 23,
	},
	{
		label: "Bike43",
		value: 295,
	},
	{
		label: "Bikerz",
		value: 408,
	},
	{
		label: "Bikle",
		value: 409,
	},
	{
		label: "Biwbik",
		value: 410,
	},
	{
		label: "BKL",
		value: 615,
	},
	{
		label: "BLB",
		value: 411,
	},
	{
		label: "BMC",
		value: 25,
	},
	{
		label: "BMW",
		value: 412,
	},
	{
		label: "Bocyclo",
		value: 413,
	},
	{
		label: "Bombtrack",
		value: 414,
	},
	{
		label: "Botch Cargo Bikes",
		value: 415,
	},
	{
		label: "Bottecchia",
		value: 26,
	},
	{
		label: "Breezer",
		value: 27,
	},
	{
		label: "Brompton",
		value: 28,
	},
	{
		label: "B'twin",
		value: 29,
	},
	{
		label: "Buke",
		value: 416,
	},
	{
		label: "Bullitt",
		value: 356,
	},
	{
		label: "Bulls",
		value: 30,
	},
	{
		label: "Cadex",
		value: 31,
	},
	{
		label: "Calendar",
		value: 417,
	},
	{
		label: "Caminade",
		value: 32,
	},
	{
		label: "Cannibal",
		value: 357,
	},
	{
		label: "Cannondale",
		value: 33,
	},
	{
		label: "Canyon",
		value: 34,
	},
	{
		label: "Capriolo",
		value: 418,
	},
	{
		label: "Carqon",
		value: 35,
	},
	{
		label: "Carraro",
		value: 36,
	},
	{
		label: "Carratt",
		value: 419,
	},
	{
		label: "Casadei",
		value: 420,
	},
	{
		label: "CBT Italia",
		value: 37,
	},
	{
		label: "Central Park",
		value: 421,
	},
	{
		label: "Centurion",
		value: 38,
	},
	{
		label: "Cervelo",
		value: 39,
	},
	{
		label: "Champion",
		value: 40,
	},
	{
		label: "Chase",
		value: 41,
	},
	{
		label: "Chike",
		value: 42,
	},
	{
		label: "Chromag",
		value: 43,
	},
	{
		label: "Cinelli",
		value: 44,
	},
	{
		label: "Cinzia",
		value: 422,
	},
	{
		label: "Ciocc",
		value: 324,
	},
	{
		label: "Cipollini",
		value: 45,
	},
	{
		label: "Citadin",
		value: 358,
	},
	{
		label: "CKT",
		value: 46,
	},
	{
		label: "Cloot",
		value: 321,
	},
	{
		label: "Coboc",
		value: 47,
	},
	{
		label: "Cobra",
		value: 423,
	},
	{
		label: "Colnago",
		value: 48,
	},
	{
		label: "Coluer",
		value: 424,
	},
	{
		label: "Commencal",
		value: 425,
	},
	{
		label: "Conway",
		value: 50,
	},
	{
		label: "Corelli",
		value: 426,
	},
	{
		label: "Corratec",
		value: 51,
	},
	{
		label: "Cortina",
		value: 427,
	},
	{
		label: "Cote",
		value: 317,
	},
	{
		label: "Cotic bikes",
		value: 52,
	},
	{
		label: "Cowboy",
		value: 53,
	},
	{
		label: "Creeks",
		value: 428,
	},
	{
		label: "Creme",
		value: 54,
	},
	{
		label: "Crussis",
		value: 318,
	},
	{
		label: "Cube",
		value: 55,
	},
	{
		label: "Cult",
		value: 56,
	},
	{
		label: "Cycle Denis",
		value: 429,
	},
	{
		label: "CyclO2",
		value: 57,
	},
	{
		label: "Cyclodebout",
		value: 430,
	},
	{
		label: "Cyfac",
		value: 58,
	},
	{
		label: "Cyrusher",
		value: 431,
	},
	{
		label: "Dacapo",
		value: 432,
	},
	{
		label: "Dahon",
		value: 59,
	},
	{
		label: "Damius",
		value: 316,
	},
	{
		label: "Dartmoor",
		value: 60,
	},
	{
		label: "De Fietsfabrik",
		value: 433,
	},
	{
		label: "De Rosa",
		value: 61,
	},
	{
		label: "Decathlon",
		value: 62,
	},
	{
		label: "Déda",
		value: 63,
	},
	{
		label: "Deed",
		value: 434,
	},
	{
		label: "Dema",
		value: 435,
	},
	{
		label: "Denver",
		value: 436,
	},
	{
		label: "Descheemaeker",
		value: 437,
	},
	{
		label: "Devinci",
		value: 64,
	},
	{
		label: "Devron",
		value: 438,
	},
	{
		label: "Di Blasi",
		value: 439,
	},
	{
		label: "Diamant",
		value: 65,
	},
	{
		label: "Dohiker",
		value: 440,
	},
	{
		label: "Dolly",
		value: 66,
	},
	{
		label: "Douze cycles",
		value: 67,
	},
	{
		label: "Duret-Geliano",
		value: 310,
	},
	{
		label: "E-mog",
		value: 332,
	},
	{
		label: "E Motion",
		value: 441,
	},
	{
		label: "E Vision",
		value: 442,
	},
	{
		label: "Easy Watts",
		value: 443,
	},
	{
		label: "Easybike",
		value: 68,
	},
	{
		label: "Ebfec",
		value: 359,
	},
	{
		label: "Eco-triporteur",
		value: 319,
	},
	{
		label: "Ecovision",
		value: 444,
	},
	{
		label: "Eddy Merckx",
		value: 69,
	},
	{
		label: "Eightshot",
		value: 445,
	},
	{
		label: "Ekoi",
		value: 446,
	},
	{
		label: "Electra",
		value: 70,
	},
	{
		label: "Eleglide",
		value: 447,
	},
	{
		label: "Eleven",
		value: 448,
	},
	{
		label: "Ellipse",
		value: 449,
	},
	{
		label: "Elops",
		value: 300,
	},
	{
		label: "Elwing",
		value: 314,
	},
	{
		label: "Engine Lab",
		value: 71,
	},
	{
		label: "Engwe",
		value: 360,
	},
	{
		label: "Eovolt",
		value: 72,
	},
	{
		label: "Eskute",
		value: 450,
	},
	{
		label: "Esperia",
		value: 451,
	},
	{
		label: "Essentielb",
		value: 452,
	},
	{
		label: "Et Cycle",
		value: 453,
	},
	{
		label: "Etyk",
		value: 454,
	},
	{
		label: "Eveo",
		value: 455,
	},
	{
		label: "E-Vision",
		value: 456,
	},
	{
		label: "Excel",
		value: 457,
	},
	{
		label: "Excelle",
		value: 458,
	},
	{
		label: "Excelsior",
		value: 74,
	},
	{
		label: "Exodus",
		value: 459,
	},
	{
		label: "EXS",
		value: 73,
	},
	{
		label: "Ezo",
		value: 460,
	},
	{
		label: "Factor",
		value: 461,
	},
	{
		label: "Fafrees",
		value: 462,
	},
	{
		label: "Faggin",
		value: 75,
	},
	{
		label: "Fahrradmanufaktur",
		value: 76,
	},
	{
		label: "Fantic",
		value: 77,
	},
	{
		label: "Felt",
		value: 78,
	},
	{
		label: "Ferrus",
		value: 305,
	},
	{
		label: "Feu Vert",
		value: 79,
	},
	{
		label: "Fictif",
		value: 463,
	},
	{
		label: "Fischer",
		value: 320,
	},
	{
		label: "Fitch",
		value: 464,
	},
	{
		label: "Fixie Inc",
		value: 80,
	},
	{
		label: "FKC",
		value: 81,
	},
	{
		label: "Flebi",
		value: 361,
	},
	{
		label: "Flyer",
		value: 82,
	},
	{
		label: "Flying-Cat",
		value: 288,
	},
	{
		label: "Focus",
		value: 83,
	},
	{
		label: "Foes",
		value: 84,
	},
	{
		label: "Freerider",
		value: 465,
	},
	{
		label: "Frog bikes",
		value: 85,
	},
	{
		label: "Fuji",
		value: 86,
	},
	{
		label: "Galian Cycles",
		value: 611,
	},
	{
		label: "Garelli",
		value: 466,
	},
	{
		label: "GasGas",
		value: 362,
	},
	{
		label: "Gaya",
		value: 467,
	},
	{
		label: "Gazelle",
		value: 87,
	},
	{
		label: "Genesis",
		value: 89,
	},
	{
		label: "Geroni",
		value: 468,
	},
	{
		label: "Ghost",
		value: 91,
	},
	{
		label: "Giant",
		value: 93,
	},
	{
		label: "Girs",
		value: 95,
	},
	{
		label: "Gitane",
		value: 97,
	},
	{
		label: "Go Sport",
		value: 99,
	},
	{
		label: "Gocycle",
		value: 101,
	},
	{
		label: "Gomier",
		value: 469,
	},
	{
		label: "Gorille Cycles",
		value: 470,
	},
	{
		label: "Granville",
		value: 103,
	},
	{
		label: "Greyp",
		value: 105,
	},
	{
		label: "Groupe Virage",
		value: 471,
	},
	{
		label: "GT Bicycle",
		value: 107,
	},
	{
		label: "Guerciotti",
		value: 472,
	},
	{
		label: "Hagen",
		value: 352,
	},
	{
		label: "Haibike",
		value: 108,
	},
	{
		label: "Haro",
		value: 109,
	},
	{
		label: "Hasebikes",
		value: 473,
	},
	{
		label: "Hercules",
		value: 110,
	},
	{
		label: "Himo",
		value: 474,
	},
	{
		label: "Histoire Bike",
		value: 475,
	},
	{
		label: "Hitway",
		value: 476,
	},
	{
		label: "Hope",
		value: 111,
	},
	{
		label: "HONBIKE",
		value: 331,
	},
	{
		label: "Hp Velotechnik",
		value: 477,
	},
	{
		label: "Husqvarna Bicycles",
		value: 112,
	},
	{
		label: "I:Sy",
		value: 478,
	},
	{
		label: "Ibis",
		value: 113,
	},
	{
		label: "Ice",
		value: 479,
	},
	{
		label: "Infine",
		value: 480,
	},
	{
		label: "Inmotion",
		value: 481,
	},
	{
		label: "Inspyre Bicycles",
		value: 114,
	},
	{
		label: "Intense",
		value: 115,
	},
	{
		label: "Ion",
		value: 482,
	},
	{
		label: "Iron Horse",
		value: 116,
	},
	{
		label: "Iweech",
		value: 117,
	},
	{
		label: "Jacques Anquetil",
		value: 118,
	},
	{
		label: "Jean Fourche",
		value: 483,
	},
	{
		label: "Jitensha",
		value: 484,
	},
	{
		label: "Jobo",
		value: 485,
	},
	{
		label: "Juliana",
		value: 119,
	},
	{
		label: "Jumpertrek",
		value: 120,
	},
	{
		label: "Kalkhoff",
		value: 121,
	},
	{
		label: "Kellys",
		value: 122,
	},
	{
		label: "Kessels",
		value: 123,
	},
	{
		label: "Kestrel",
		value: 124,
	},
	{
		label: "Kettler",
		value: 125,
	},
	{
		label: "KHE",
		value: 126,
	},
	{
		label: "KHS",
		value: 127,
	},
	{
		label: "Kiffy",
		value: 128,
	},
	{
		label: "Kink BMX",
		value: 129,
	},
	{
		label: "Kino Bikes",
		value: 333,
	},
	{
		label: "Kiny",
		value: 486,
	},
	{
		label: "Kiss Ebikes",
		value: 487,
	},
	{
		label: "Knolly",
		value: 130,
	},
	{
		label: "Koga",
		value: 131,
	},
	{
		label: "Kona",
		value: 132,
	},
	{
		label: "Kreidler",
		value: 488,
	},
	{
		label: "Kron",
		value: 363,
	},
	{
		label: "Kross",
		value: 133,
	},
	{
		label: "KS Cycling",
		value: 134,
	},
	{
		label: "KTM",
		value: 135,
	},
	{
		label: "Kuota",
		value: 136,
	},
	{
		label: "Kuster",
		value: 489,
	},
	{
		label: "Kuwahara",
		value: 137,
	},
	{
		label: "Laeder Fox",
		value: 490,
	},
	{
		label: "Lapierre",
		value: 138,
	},
	{
		label: "Larrun",
		value: 379,
	},
	{
		label: "Larry Vs Harry",
		value: 491,
	},
	{
		label: "Leader Fox",
		value: 493,
	},
	{
		label: "Legend Ebikes",
		value: 494,
	},
	{
		label: "Legnano",
		value: 495,
	},
	{
		label: "Lejeune",
		value: 139,
	},
	{
		label: "Levit",
		value: 364,
	},
	{
		label: "Litespeed",
		value: 140,
	},
	{
		label: "Liteville",
		value: 141,
	},
	{
		label: "Liv",
		value: 297,
	},
	{
		label: "Logo",
		value: 142,
	},
	{
		label: "Lombardo",
		value: 289,
	},
	{
		label: "Longway",
		value: 496,
	},
	{
		label: "Look",
		value: 143,
	},
	{
		label: "Lotus",
		value: 497,
	},
	{
		label: "Lutetia",
		value: 144,
	},
	{
		label: "Maabikes",
		value: 145,
	},
	{
		label: "Mad (Le Vélo Mad)",
		value: 146,
	},
	{
		label: "Magnum",
		value: 498,
	},
	{
		label: "Makadam",
		value: 499,
	},
	{
		label: "Marin",
		value: 147,
	},
	{
		label: "Marlin",
		value: 500,
	},
	{
		label: "Massi",
		value: 148,
	},
	{
		label: "Master",
		value: 501,
	},
	{
		label: "Mate",
		value: 502,
	},
	{
		label: "Matra",
		value: 149,
	},
	{
		label: "Mbe",
		value: 503,
	},
	{
		label: "MBK",
		value: 150,
	},
	{
		label: "MBM",
		value: 290,
	},
	{
		label: "Mc Dis",
		value: 504,
	},
	{
		label: "Mecer",
		value: 151,
	},
	{
		label: "Megamo",
		value: 294,
	},
	{
		label: "Meral",
		value: 505,
	},
	{
		label: "Mercier",
		value: 152,
	},
	{
		label: "Merida Bikes",
		value: 312,
	},
	{
		label: "Merida",
		value: 154,
	},
	{
		label: "Merlin",
		value: 153,
	},
	{
		label: "Meybo",
		value: 155,
	},
	{
		label: "Mfc",
		value: 506,
	},
	{
		label: "Micmo",
		value: 156,
	},
	{
		label: "Micro Mobility",
		value: 507,
	},
	{
		label: "Minerva",
		value: 365,
	},
	{
		label: "Mobi Move",
		value: 508,
	},
	{
		label: "Mobius",
		value: 509,
	},
	{
		label: "Moma",
		value: 157,
	},
	{
		label: "Momabikes",
		value: 510,
	},
	{
		label: "Momentum Electric",
		value: 511,
	},
	{
		label: "Mondraker",
		value: 158,
	},
	{
		label: "Mongoose",
		value: 159,
	},
	{
		label: "Monspad",
		value: 512,
	},
	{
		label: "Montana",
		value: 160,
	},
	{
		label: "Monty",
		value: 161,
	},
	{
		label: "Mooby",
		value: 513,
	},
	{
		label: "Moov'in",
		value: 366,
	},
	{
		label: "Moovway",
		value: 514,
	},
	{
		label: "Motobécane",
		value: 162,
	},
	{
		label: "Moustache",
		value: 163,
	},
	{
		label: "Mouvelec",
		value: 515,
	},
	{
		label: "Movea",
		value: 164,
	},
	{
		label: "MSC",
		value: 165,
	},
	{
		label: "Muddy Fox",
		value: 166,
	},
	{
		label: "Multicycle",
		value: 516,
	},
	{
		label: "Muon",
		value: 517,
	},
	{
		label: "Nakamura",
		value: 167,
	},
	{
		label: "Ncm",
		value: 518,
	},
	{
		label: "Neatt",
		value: 301,
	},
	{
		label: "Neomouv",
		value: 168,
	},
	{
		label: "Neon",
		value: 519,
	},
	{
		label: "Nicolaï",
		value: 169,
	},
	{
		label: "Nihola",
		value: 520,
	},
	{
		label: "Nijland",
		value: 521,
	},
	{
		label: "Niner",
		value: 170,
	},
	{
		label: "Norco",
		value: 171,
	},
	{
		label: "Nox",
		value: 172,
	},
	{
		label: "NS bikes",
		value: 173,
	},
	{
		label: "Nukeproof",
		value: 174,
	},
	{
		label: "O2 Feel",
		value: 183,
	},
	{
		label: "Oklö",
		value: 522,
	},
	{
		label: "Olmo",
		value: 175,
	},
	{
		label: "Olympia",
		value: 523,
	},
	{
		label: "Omnium",
		value: 524,
	},
	{
		label: "On One",
		value: 176,
	},
	{
		label: "Onemile",
		value: 525,
	},
	{
		label: "Onesport",
		value: 526,
	},
	{
		label: "Open",
		value: 527,
	},
	{
		label: "Optim'alp",
		value: 177,
	},
	{
		label: "Orange",
		value: 180,
	},
	{
		label: "Orbea",
		value: 178,
	},
	{
		label: "Orbita",
		value: 179,
	},
	{
		label: "Origine",
		value: 181,
	},
	{
		label: "Ortler",
		value: 182,
	},
	{
		label: "Oto Bike",
		value: 528,
	},
	{
		label: "Ovelo",
		value: 529,
	},
	{
		label: "Oxford",
		value: 530,
	},
	{
		label: "Panther",
		value: 184,
	},
	{
		label: "Patria",
		value: 531,
	},
	{
		label: "Pegasus",
		value: 291,
	},
	{
		label: "Pelago",
		value: 532,
	},
	{
		label: "Pelican Cycles",
		value: 614,
	},
	{
		label: "Peugeot",
		value: 185,
	},
	{
		label: "Pfautec",
		value: 533,
	},
	{
		label: "Picwictoys",
		value: 534,
	},
	{
		label: "Pinarello",
		value: 186,
	},
	{
		label: "Pivot Cycles",
		value: 187,
	},
	{
		label: "Polygon",
		value: 188,
	},
	{
		label: "Position One",
		value: 189,
	},
	{
		label: "Private Label",
		value: 535,
	},
	{
		label: "Production privée",
		value: 190,
	},
	{
		label: "Proline",
		value: 536,
	},
	{
		label: "Propain",
		value: 313,
	},
	{
		label: "Prophete",
		value: 537,
	},
	{
		label: "Proxy",
		value: 538,
	},
	{
		label: "Puch",
		value: 191,
	},
	{
		label: "Puky",
		value: 539,
	},
	{
		label: "Q bikes",
		value: 193,
	},
	{
		label: "Quantum",
		value: 192,
	},
	{
		label: "Rabeneick",
		value: 194,
	},
	{
		label: "Rad (Power) Bike ",
		value: 195,
	},
	{
		label: "Radio Bikes",
		value: 196,
	},
	{
		label: "RADIOR",
		value: 616,
	},
	{
		label: "Radon",
		value: 197,
	},
	{
		label: "Raleigh",
		value: 198,
	},
	{
		label: "Raymon",
		value: 199,
	},
	{
		label: "Rayvolt bikes",
		value: 200,
	},
	{
		label: "Red Will",
		value: 612,
	},
	{
		label: "Redline",
		value: 201,
	},
	{
		label: "REF Bikes",
		value: 613,
	},
	{
		label: "Reid",
		value: 540,
	},
	{
		label: "Revoe",
		value: 541,
	},
	{
		label: "Ridgeback",
		value: 542,
	},
	{
		label: "Ridley",
		value: 203,
	},
	{
		label: "Rieju",
		value: 543,
	},
	{
		label: "Riese & Müller",
		value: 202,
	},
	{
		label: "Ritchey",
		value: 204,
	},
	{
		label: "Riva",
		value: 544,
	},
	{
		label: "Riverside",
		value: 299,
	},
	{
		label: "Riviera",
		value: 545,
	},
	{
		label: "Rixe",
		value: 546,
	},
	{
		label: "Rock Machine",
		value: 367,
	},
	{
		label: "Rockrider",
		value: 205,
	},
	{
		label: "Rocky Mountain",
		value: 206,
	},
	{
		label: "Romet",
		value: 296,
	},
	{
		label: "Rondo",
		value: 207,
	},
	{
		label: "Rook",
		value: 547,
	},
	{
		label: "Rose",
		value: 208,
	},
	{
		label: "Rossignol",
		value: 209,
	},
	{
		label: "Rotwild",
		value: 210,
	},
	{
		label: "Ruff Cycles",
		value: 211,
	},
	{
		label: "Samebike",
		value: 212,
	},
	{
		label: "Santa Cruz",
		value: 213,
	},
	{
		label: "Saracen",
		value: 548,
	},
	{
		label: "Sauvage",
		value: 549,
	},
	{
		label: "Scamp",
		value: 302,
	},
	{
		label: "Schiano",
		value: 550,
	},
	{
		label: "Schindelhaueur",
		value: 551,
	},
	{
		label: "Schwinn",
		value: 214,
	},
	{
		label: "S'Cool",
		value: 552,
	},
	{
		label: "Scooty",
		value: 553,
	},
	{
		label: "Scor",
		value: 368,
	},
	{
		label: "Scott",
		value: 215,
	},
	{
		label: "Scrapper",
		value: 216,
	},
	{
		label: "Se Bikes",
		value: 554,
	},
	{
		label: "SE Racing",
		value: 218,
	},
	{
		label: "Sensa",
		value: 306,
	},
	{
		label: "Serious",
		value: 217,
	},
	{
		label: "Seven",
		value: 219,
	},
	{
		label: "Shengmilo",
		value: 293,
	},
	{
		label: "Shift Bikes",
		value: 555,
	},
	{
		label: "Simmonsohn",
		value: 556,
	},
	{
		label: "Simplon",
		value: 220,
	},
	{
		label: "Sinus",
		value: 221,
	},
	{
		label: "Sirius",
		value: 222,
	},
	{
		label: "Smoby",
		value: 303,
	},
	{
		label: "Smovengo",
		value: 557,
	},
	{
		label: "Sobre",
		value: 223,
	},
	{
		label: "Solar",
		value: 558,
	},
	{
		label: "Solex",
		value: 224,
	},
	{
		label: "Sparta",
		value: 225,
	},
	{
		label: "Specialized",
		value: 226,
	},
	{
		label: '"Speedfox',
		value: 369,
	},
	{
		label: "Spego",
		value: 227,
	},
	{
		label: "Stalhasten",
		value: 559,
	},
	{
		label: "Star",
		value: 560,
	},
	{
		label: "Star Lady",
		value: 561,
	},
	{
		label: "Starway",
		value: 228,
	},
	{
		label: "State Bicycle",
		value: 562,
	},
	{
		label: "Stealth Electric Bikes",
		value: 322,
	},
	{
		label: "Stevens",
		value: 370,
	},
	{
		label: "Stilus",
		value: 304,
	},
	{
		label: "Storck",
		value: 229,
	},
	{
		label: '"Streetstepper',
		value: 371,
	},
	{
		label: "Strida",
		value: 230,
	},
	{
		label: "Stromer ",
		value: 231,
	},
	{
		label: "Subrosa",
		value: 232,
	},
	{
		label: "Sudwest",
		value: 563,
	},
	{
		label: "Sunday Bikes",
		value: 233,
	},
	{
		label: "Sunn",
		value: 234,
	},
	{
		label: "Super73",
		value: 564,
	},
	{
		label: "Superior",
		value: 565,
	},
	{
		label: "Surly",
		value: 351,
	},
	{
		label: "Surpass",
		value: 566,
	},
	{
		label: "Swift",
		value: 235,
	},
	{
		label: "Swype",
		value: 236,
	},
	{
		label: "Taboo",
		value: 353,
	},
	{
		label: "Talbot",
		value: 237,
	},
	{
		label: "T-bird",
		value: 238,
	},
	{
		label: "Tern",
		value: 239,
	},
	{
		label: "TENWAYS",
		value: 330,
	},
	{
		label: "Thirty One",
		value: 240,
	},
	{
		label: "Thompson",
		value: 373,
	},
	{
		label: "Tilgreen",
		value: 241,
	},
	{
		label: "Time",
		value: 242,
	},
	{
		label: "Titici",
		value: 243,
	},
	{
		label: "TKS",
		value: 567,
	},
	{
		label: "Toimsa",
		value: 568,
	},
	{
		label: "Top Gun",
		value: 245,
	},
	{
		label: "Topbike",
		value: 244,
	},
	{
		label: "Toplife",
		value: 569,
	},
	{
		label: "Torker",
		value: 246,
	},
	{
		label: "Torpado",
		value: 247,
	},
	{
		label: "Transition",
		value: 248,
	},
	{
		label: "Treebike",
		value: 570,
	},
	{
		label: "Trek",
		value: 249,
	},
	{
		label: "Triban",
		value: 298,
	},
	{
		label: "Triobike",
		value: 571,
	},
	{
		label: "Turner",
		value: 250,
	},
	{
		label: "TVT",
		value: 572,
	},
	{
		label: "ULTIMA Mobility",
		value: 334,
	},
	{
		label: "Unik Ride",
		value: 573,
	},
	{
		label: "Union",
		value: 252,
	},
	{
		label: "United Cruiser",
		value: 574,
	},
	{
		label: "Univega",
		value: 253,
	},
	{
		label: "Urban Arrow",
		value: 254,
	},
	{
		label: "Urbanglide",
		value: 575,
	},
	{
		label: "Vaast",
		value: 255,
	},
	{
		label: "Vagabonde Cycles",
		value: 374,
	},
	{
		label: "Van Dijck",
		value: 256,
	},
	{
		label: "Van Moof",
		value: 257,
	},
	{
		label: "Van Raam",
		value: 576,
	},
	{
		label: "Van Rysel",
		value: 258,
	},
	{
		label: "Vario",
		value: 259,
	},
	{
		label: "Vässla",
		value: 577,
	},
	{
		label: "Vaucluse",
		value: 578,
	},
	{
		label: "Vektor",
		value: 579,
	},
	{
		label: "Velair",
		value: 260,
	},
	{
		label: "Velcan",
		value: 580,
	},
	{
		label: "Vellia",
		value: 581,
	},
	{
		label: "Vello",
		value: 582,
	},
	{
		label: "Velobecane",
		value: 261,
	},
	{
		label: "Veloce",
		value: 583,
	},
	{
		label: "Velo-de-ville",
		value: 308,
	},
	{
		label: "Veloe",
		value: 584,
	},
	{
		label: "Veloretti",
		value: 585,
	},
	{
		label: "Velys",
		value: 586,
	},
	{
		label: "Velyvelo",
		value: 587,
	},
	{
		label: "Vendetta",
		value: 262,
	},
	{
		label: "Venilu",
		value: 264,
	},
	{
		label: "Ventana",
		value: 263,
	},
	{
		label: "Vepli",
		value: 588,
	},
	{
		label: "Verlyn",
		value: 375,
	},
	{
		label: "Vermont",
		value: 265,
	},
	{
		label: "Vg Bikes",
		value: 589,
	},
	{
		label: "Via Veneto",
		value: 266,
	},
	{
		label: "Vicini",
		value: 590,
	},
	{
		label: "Victoire",
		value: 267,
	},
	{
		label: "Victoria",
		value: 376,
	},
	{
		label: "Viper",
		value: 591,
	},
	{
		label: "Virage",
		value: 377,
	},
	{
		label: "Vitus",
		value: 268,
	},
	{
		label: "Vogue",
		value: 592,
	},
	{
		label: "Volare",
		value: 593,
	},
	{
		label: "Voltaire",
		value: 594,
	},
	{
		label: "Voodoo",
		value: 269,
	},
	{
		label: "Votec",
		value: 270,
	},
	{
		label: "VUF",
		value: 271,
	},
	{
		label: "Wanderer",
		value: 273,
	},
	{
		label: "Watson",
		value: 595,
	},
	{
		label: "Watt",
		value: 596,
	},
	{
		label: "Wattitud",
		value: 597,
	},
	{
		label: "Wayscral",
		value: 272,
	},
	{
		label: "Wee Go Smart",
		value: 598,
	},
	{
		label: "Wegoboard",
		value: 599,
	},
	{
		label: "Wello",
		value: 600,
	},
	{
		label: "Welt",
		value: 601,
	},
	{
		label: "Wethepeople",
		value: 602,
	},
	{
		label: "Whattfornow",
		value: 603,
	},
	{
		label: "Whe The People",
		value: 274,
	},
	{
		label: "Wheeler",
		value: 275,
	},
	{
		label: "Wheelyoo",
		value: 604,
	},
	{
		label: "Whistle",
		value: 276,
	},
	{
		label: "White bikes",
		value: 277,
	},
	{
		label: "Whyte",
		value: 278,
	},
	{
		label: "Wilier Triestina",
		value: 279,
	},
	{
		label: "Winora",
		value: 280,
	},
	{
		label: "Woodee",
		value: 605,
	},
	{
		label: "Woodsun",
		value: 311,
	},
	{
		label: "Woom",
		value: 606,
	},
	{
		label: "XCYC",
		value: 607,
	},
	{
		label: "Xiaomi",
		value: 281,
	},
	{
		label: "Yamaha",
		value: 335,
	},
	{
		label: "Yeep.Me",
		value: 608,
	},
	{
		label: "Yeti",
		value: 282,
	},
	{
		label: "Ymagine",
		value: 609,
	},
	{
		label: "Yokler",
		value: 284,
	},
	{
		label: "YT Industries",
		value: 283,
	},
	{
		label: "Yuba",
		value: 285,
	},
	{
		label: "Zelectrification",
		value: 378,
	},
	{
		label: "Zoov",
		value: 610,
	},
	{
		label: "Zumbi",
		value: 286,
	},
]

export const getBrandLabelFromValue = (bikeValue: number) =>
	bikeBrands.find((type) => type.value === bikeValue)?.label

export const getBrandValueFromLabel = (bikelabel: string) =>
	bikeBrands.find((type) => type.label === bikelabel)?.value
